import React from "react";
import dynamic from "next/dynamic";
import { WaitForConfig } from "../../components/WaitForConfig";
import { OVERLAY_TYPE } from "../../hooks/useOverlaySettings";

// Need to dynamic import this because Alert Page need Audio that cant work on SSR
const MediaShare = dynamic(() => import("../../PagesComponent/_mediashare"), {
  ssr: false,
});

const MediaShareWidget = () => {
  return (
    <WaitForConfig
      Component={MediaShare}
      overlayType={OVERLAY_TYPE.MEDIASHARE}
    />
  );
};

export default MediaShareWidget;
